<template>
  <div class="tab-bar" :class="className">
    <div v-for="(item, index) in titles" :key="index">
      <div
        @click="titleClick(index)"
        :class="{ active: currentIndex === index }"
      >
        {{ item }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'TabBar',
  props: {
    titles: {
      type: Array,
      default: () => []
    },
    className: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      currentIndex: 0
    };
  },
  methods: {
    titleClick (index) {
      this.currentIndex = index;
      this.$emit('titleClick', index);
    }
  }
};
</script>
<style lang="less" scoped>
  @import url('./index.less');
</style>



// WEBPACK FOOTER //
// src/pages/tideng/new-version/TabBar/index.vue